import { render } from "./fugaolinchuang-news.vue?vue&type=template&id=7ea73386&scoped=true"
import script from "./fugaolinchuang-news.vue?vue&type=script&lang=js"
export * from "./fugaolinchuang-news.vue?vue&type=script&lang=js"

import "./fugaolinchuang-news.vue?vue&type=style&index=0&id=7ea73386&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ea73386"]])

export default __exports__